export default __webpack_public_path__ + "static/media/Liveness Detection.4044166b.png";